import inflection from 'inflection'
import Vue from 'vue'

const newBucket = { name: "New Bucket", kpi: "current_state", displayFields: [], criteria: [], displayGroupByPanel: true }

export default {
  addParticipantToBucket(state, { participant, type }) {
    state.current.bucket.participants.push({ id: participant.id, displayName: participant.displayName, __typename: inflection.capitalize(type) })
  },
  removeParticipantFromBucket(state, { participant, type }) {
    const ctype = inflection.capitalize(type)
    const idx = state.current.bucket.participants.findIndex(p => p.id === participant.id && ctype === p.__typename)
    if (idx >= 0) {
      state.current.bucket.participants.splice(idx, 1)
      Vue.set(state.current.bucket, "participants", [...state.current.bucket.participants])
    }
  },
  setBucketBookmarked(state, isBookmarked) {
    state.current.bookmarked = isBookmarked
  },
  setBuckets(state, buckets) {
    state.buckets = buckets
  },
  requestingBuckets(state) {
    state.loading = true
  },
  receivedBuckets(state) {
    state.loading = false
  },
  clearBucket(state) {
    Vue.set(state.current, "bucket", {
      name: '',
      description: '',
      kpi: '',
      advancedQuery: '',
      displayFields: [],
      criteria: [],
      displayGroupByPanel: true
    })
  },
  requestingBucket(state) {
    state.current.loading = true
  },
  receivedBucket(state) {
    state.current.loading = false
  },
  setBucket(state, bucket) {
    state.current.bucket = bucket
  },
  setBucketCaseViewers(state, data) {
    const ids = state.current.bucket.contents.cases.map(c => c.id)
    const index = ids.indexOf(data.caseId)
    if (index >= 0) {
      state.current.bucket.contents.cases[index].currentlyViewing = data.viewers ? data.viewers.viewers : []
    }
  },
  setBucketMapPoints(state, mapPoints) {
    Vue.set(state.current.bucket, "mapPoints", [...mapPoints])
  },
  setBucketOwner(state, { owner, type }) {
    state.current.bucket.owner = {
      __typename: inflection.capitalize(type),
      displayName: owner.displayName
    }
  },
  setCaseType(state, caseType) {
    state.current.caseType = caseType
  },
  setCases(state, cases) {
    state.current.cases = cases
    Vue.set(state.current, "cases", [...cases])
  },
  setTasklistTemplates(state, tasklists) {
    Vue.set(state.current, "tasklists", [...tasklists])
  },
  setHeaders(state, headers) {
    Vue.set(state.current, "headers", [...headers])
  },
  setSchema(state, schema) {
    state.current.schema = schema
  },
  setBucketDisplayFields(state, fields) {
    Vue.set(state.current.bucket, "displayFields", [...fields])
  },
  setBucketFilterFields(state, fields) {
    Vue.set(state.current.bucket, "criteria", [...fields])
  },
  setBucketSortFields(state, fields) {
    Vue.set(state.current.bucket, "sortFields", [...fields])
  },
  prepareNewBucket(state) {
    state.current.bucket = newBucket
  },
  setHasChanged(state, changed) {
    state.current.bucketGroup.hasChanged = changed
  },
  setCurrentBucketGroup(state, bucketGroup) {
    state.current.bucketGroup.name = bucketGroup.name
    state.current.bucketGroup.buckets = bucketGroup.buckets
  }
}
